import { render } from "./EditSalaryComponent.vue?vue&type=template&id=7e30bab4&scoped=true"
import script from "./EditSalaryComponent.vue?vue&type=script&lang=js"
export * from "./EditSalaryComponent.vue?vue&type=script&lang=js"

import "./EditSalaryComponent.vue?vue&type=style&index=0&id=7e30bab4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e30bab4"]])

export default __exports__